const MD_LINKS = /\[([^\]]*)]\(([^)]*)\)/g; // [markdown link](articlename.md)
const REFERENCE_STYLE_LINKS = /\[\s*([a-zA-Z0-9_ -.]+)\s*\]\s*:\s*(\S+)\s*("".*?"")?/gi; // [hobbit-hole][1] [1]: https://en.wikipedia.org/wiki/Hobbit#Lifestyle,  source:https://www.markdownguide.org/basic-syntax/#reference-style-links
const CODE_BLOCK = '```([^`]*)```'; // ``` some code ```
const INLINE_CODE = '`([^`].*?)`'; // `inline code`
const ALL_CODE_BLOCKS = new RegExp(`${CODE_BLOCK}|${INLINE_CODE}`, 'g'); // code block or inline code, example: https://regex101.com/r/sUOrE9/1

export const REGEXES = {
  MD_LINKS,
  REFERENCE_STYLE_LINKS,
  MD_LINKS_ARRAY: [MD_LINKS, REFERENCE_STYLE_LINKS],
  DO_NOT_REPLACE: /::(DoNotReplace)/gi,
  CODE_BLOCK: /```([^`]*)```/g,
  INLINE_CODE: /`([^`].*?)`/g,
  ALL_CODE_BLOCKS,
  PATH_TRAVERSAL: /\.\.\/|\.\//g,
};

export const FLAGS = {
  DO_NOT_REPLACE: '::DoNotReplace',
  REFERENCE_STYLE_LINKS_PREFIX: ']:',
  MD_LINKS_PREFIX: '](',
};
